import { isEqual } from 'lodash'

import { getString } from '@sigma-frontend-libs/commons'

import { proxy } from '@/utils'

import render from './render'

const className = 'radio-card'

export default {
  name: 'RadioCard',

  mixins: [ proxy() ],

  props: {
    cardValue: {
      type: null,
      default: undefined
    },

    label: {
      type: [ String, Number, Boolean ],
      default: undefined
    },
    info: {
      type: [ String, Number, Boolean ],
      default: undefined
    },

    color: {
      type: String,
      default: undefined
    },

    outline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    $_class() {
      return {
        [className]: true,
        [`${className}--${this.color}`]: !!this.color,
        [`${className}--checked`]: this.checked,
        [`${className}--outline`]: this.outline,
        [`${className}--disabled`]: this.disabled
      }
    },

    $_label() {
      return getString(this.label)
    },
    $_info() {
      return getString(this.info)
    },

    checked() {
      return isEqual(this.cardValue, this.proxy)
    }
  },

  methods: {
    clickHandler() {
      if (!this.disabled) {
        this.proxy = this.cardValue
      }
    }
  },

  render
}
